/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import ModalDialog from '../../ModalDialog';
import { Accordion, AccordionDetails, AccordionSummary, Button, Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import Datagrid from '../../Datagrid';
import PropTypes from 'prop-types';
import { CancelPresentationRounded, LogoutOutlined, PersonAddAlt, SaveRounded, ShortcutOutlined, TableViewOutlined } from '@mui/icons-material';
import columns from './table_config';
import { GridExpandMoreIcon, useGridApiRef } from '@mui/x-data-grid-pro';
import { addNewHydraulicsDetailsRow, createHydraulicsDetails, listHydraulicsDetails, runHydraulics, updateHydraulicsDetails } from '../../../../store/actions/hydraulics';
import { useDispatch, useSelector } from 'react-redux';
import { enqueueSnackbar } from '../../../../store/actions/snackbar';
import SelectEditInputTextField from '../../SelectEditInputTextField';
import { ANCHOR_POINT_TYPES, APP_ACTION_TYPES, CONTROL_TABLE_PARAMETER_MAP, HIDE_TARGET_IN_RUN_TYPE, HYDRAULICS_MODEL, HYDRAULICS_MODEL_VALUES, HYDRAULICS_RUN_DETAILS, PERMISSION_DIALOG_SOURCES, SHORTCUT_LISTS_HYDRAULICS, TOOLTIPS, WELLBORE_DRILL_FLUID } from '../../../../utils/constants';
import CuttingPropertyModal from '../CuttingPropertyModal';
import styles from './styles';
import useUnsavedChanges from '../../../../hooks/useUnsavedChanges';
import useUnitConversion from '../../../../hooks/useUnitConversion';
import { UNIT_SYSTEM } from '../../../../shared/config/hydraulics_constants';
import { COLORS } from '../../../../shared/config/colors';
import Wellbore from '../Wellbore';
import RolloverModal from '../RolloverModal';
import StrippingModal from '../StrippingModal';
import ParametricAnalysisModal from '../ParametricAnalysisModal';
import DisplacementModal from '../DisplacementModal';
import { runStrippingAnalysis } from '../../../../store/actions/stripping';
import { runParametricAnalysis } from '../../../../store/actions/hydraulicsParameterAnalysis';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';
import { runDisplacement } from '../../../../store/actions/hydraulicsDisplacement';
import { runRolloverProxy } from '../../../../store/actions/hydraulicsRollover';
import SelectEditValueTypes from '../../SelectEditValueTypes';
import WellboreVolumeModal from '../WellboreVolumeCalculator';
import WindowModal from '../../../window';
import DrillFluidModal from '../../../drillFluid';
import DrillStringModal from '../../../drillString';
import GeometryModal from '../../../geometry';
import SurveyModal from '../../../survey';
import MudPumpModel from '../MudPumpModal';
import { listObservation } from '../../../../store/actions/observation';
import PermissionsModal from '../../../permissions';
import _ from 'lodash';
import { checkHydraulicsAdmin, checkPermissions } from '../../../../utils/checkPermissions';
import CreatedByInfoDialog from '../../CreatedByInfoDialog';

const HydraulicsDetailsModal = ({
  onCloseClick,
  selectedJob,
  isOpen,
  data,
  dialogParameter,
  wellDetails
}) => {
  const classes = styles();
  const apiRef = useGridApiRef();
  const hydraulics = useSelector((state) => state.hydraulics);
  const stripping = useSelector((state) => state.stripping);
  const rollover = useSelector((state) => state.rollover);
  const dispatch = useDispatch();
  const [properties, setProperties] = useState([]);
  const [accordionProperty, setAccordionProperty] = useState([]);
  const [invalidRows, setInvalidRows] = useState({});
  const [hydraulicsExitRunIcon, setHydraulicsExitRunIcon] = useState(true);
  const { unit, convertUnitSystem } = useUnitConversion();
  const [anchorPoint, setAnchorPoint] = useState('None');
  const [targetECD, setTargetECD] = useState('');
  const observation = useSelector((state) => state.observation);
  const hydraulicsParameter = useSelector((state) => state.hydraulicsParameterAnalysis);
  const hydraulicsDisplacement = useSelector((state) => state.displacement);
  const {
    unSavedExists,
    handleClose,
    UnsavedChangesModal
  } = useUnsavedChanges(properties, onCloseClick, accordionProperty);
  const [targetData, setTargetData] = useState({});
  const [cuttingData, setCuttingData] = useState({});
  const [updateCuttingData, setUpdateCuttingData] = useState({});
  const [invalidCuttingRows, setInvalidCuttinRows] = useState({});
  const [invalidWellInitRows, setInvalidWellInitRows] = useState({});
  const [wellbore, setWellbore] = useState({
    pipe: [],
    annular: []
  });
  const [checkWellbore, setCheckWellbore] = useState(false);
  const [hydraulicParameterData, setHydraulicsParameterData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [volumeCalculatorModal, setVolumeCalculatorModal] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [calculatedFlowRate, setCalculatedFlowRate] = useState('');
  const [showMudPumps, setShowMudPumps] = useState(false);
  const [initialTargetData, setInitialTargetData] = useState({});
  const user = useSelector((state) => state.currentUser);
  const [permissions, setPermissions] = useState({
    open: false,
    data: {}
  });
  const isHydraulicsAdmin = checkHydraulicsAdmin(
    user?.type,
    user?.accessLevels
  );
  const disableAction = hydraulics.details.loading || properties.some(item => item.isDirtyAccordion === true) || accordionProperty.some(item => item.isDirty === true) || properties.some(item => item?.isDirty === true);

  const handleOpen = (key) => setOpenModal(key);
  const handleCloseDialog = () => setOpenModal(null);

  useEffect(() => {
    if (isOpen) {
      dispatch(listObservation(selectedJob?.wellsInfoId));
    }
  }, [isOpen]);

  useEffect(() => {
    if (loader) {
      document.body.style.cursor = 'wait';
    } else {
      document.body.style.cursor = 'default';
    }
    return () => {
      document.body.style.cursor = 'default';
    };
  }, [loader]);

  useEffect(() => {
    const targetData = hydraulics?.details?.data?.[0]?.target_data;
    const decimals = hydraulics?.units?.inputs?.target_data?.target_ecd?.decimals ?? 2;
    setAnchorPoint(targetData?.anchor_point || 'None');
    setCuttingData(hydraulics?.details?.data?.[0]?.cuttings_data);
    setUpdateCuttingData(hydraulics?.details?.data?.[0]?.cuttings_data);
    setTargetData(targetData || {});
    setInitialTargetData(targetData || {});
    const convertedECD = parseFloat(targetData?.target_ecd);
    setTargetECD(Number(convertedECD) ? convertedECD.toFixed(decimals) : '');
  }, [hydraulics]);

  useEffect(() => {
    if (observation?.data?.length && !hydraulics.details.loading) {
      const targetData = hydraulics?.details?.data?.[0]?.target_data;
      const anchorPoint = targetData?.anchor_point;

      const extractObservationNames = observation.data.map(item => item.name);
      const updatedAnchorTypes = [...new Set([...ANCHOR_POINT_TYPES, ...extractObservationNames])];

      if (anchorPoint && !updatedAnchorTypes.includes(anchorPoint)) {
        dispatch(
          enqueueSnackbar(
            'Current Anchor Point is not available in the list. Please update',
            'error',
            new Date().getTime() + Math.random()
          )
        );
      }
    }
  }, [hydraulics, observation.loading]);

  useEffect(() => {
    if (!hydraulics.details.loading && !hydraulics?.drillDetails?.loading && !observation.loading) {
      const { data: runDetails = [] } = hydraulics.details;
      const extractObservationNames = observation.data.map(item => item?.name);
      const updatedAnchorTypes = [...new Set([...ANCHOR_POINT_TYPES, ...extractObservationNames])];
      const { drillStrings = [], drillFluids = [] } = hydraulics?.drillDetails?.hydraulicsDrillDetails || {};
      const drillFluidsWithAir = [...drillFluids, WELLBORE_DRILL_FLUID];
      if (runDetails.length) {
        const [firstRunDetail] = runDetails;
        let hasDeletedWellInitFluid = false;
        if (firstRunDetail?.well_init?.pipe?.length || firstRunDetail?.well_init?.annular?.length) {
          const units = hydraulics?.drillDetails?.units?.MD || { decimals: 2, label: 'm' };
          const formatFluid = (id) => {
            const fluid = drillFluidsWithAir.find((item) => item._id === id);
            return fluid
              ? `${fluid.name.trim()} @ ${fluid.MD.toFixed(units.decimals)}${units.label}`
              : '';
          };

          const transformWellInitData = (data) =>
            data.map((detail) => {
              const fluidExists = drillFluidsWithAir.some(fluid => fluid._id === detail.fluid_id);

              if (!fluidExists) {
                hasDeletedWellInitFluid = true;
              }

              return {
                ...detail,
                from: Number(detail.from),
                to: Number(detail.to),
                fluid_id: fluidExists ? formatFluid(detail.fluid_id) : '',
              };
            });

          const transformedPipe = firstRunDetail?.well_init?.pipe.length ? transformWellInitData(firstRunDetail.well_init.pipe) : [];
          const transformedAnnular = firstRunDetail?.well_init?.annular.length ? transformWellInitData(firstRunDetail.well_init.annular) : [];

          setWellbore({
            pipe: transformedPipe,
            annular: transformedAnnular,
          });

          if (!properties?.length && hasDeletedWellInitFluid) {
            setCheckWellbore(true);
            setInvalidWellInitRows((prev) => ({ ...prev, [firstRunDetail._id]: true }));
            dispatch(
              enqueueSnackbar(
                'Configured Drillfluid in Wellbore Initialization is not found, Please Check',
                'error',
                new Date().getTime() + Math.random()
              )
            );
          } else { setCheckWellbore(false); }
        } else {
          setWellbore({
            pipe: [],
            annular: []
          });
        }
        const checkForDeletedDrillStringId = drillStrings.some(drillString => drillString._id === firstRunDetail.drillStringsId);
        const checkForDeletedDrillFluidId = drillFluids.some(drillString => drillString._id === firstRunDetail.drillFluidsId);

        if (!properties?.length) {
          const errors = [];

          if (!checkForDeletedDrillFluidId) {
            errors.push('Configured Drilling Fluid in Wellbore is not found, Please Check');
          }

          if (!checkForDeletedDrillStringId) {
            errors.push('Configured Drillstring in Wellbore is not found, Please Check');
          }

          if (errors?.length) {
            setInvalidWellInitRows((prev) => ({ ...prev, [firstRunDetail._id]: true }));
          }

          errors.forEach(message => {
            dispatch(
              enqueueSnackbar(
                message,
                'error',
                Date.now() + Math.random()
              )
            );
          });
        }

        const checkForDeletedAnchorPoint =
          !firstRunDetail?.target_data || Object.keys(firstRunDetail.target_data).length === 0 || !firstRunDetail?.target_data?.anchor_point || firstRunDetail?.target_data?.anchor_point === 'None'
            ? true
            : updatedAnchorTypes.includes(firstRunDetail?.target_data?.anchor_point);
        if (checkForDeletedDrillStringId && checkForDeletedDrillFluidId && checkForDeletedAnchorPoint && !hasDeletedWellInitFluid) {
          setHydraulicsExitRunIcon(false);
        } else {
          setHydraulicsExitRunIcon(true);
        }
        const updatedRunDetails = runDetails.map(detail => {
          const drillString = drillStrings.find(item => item._id === detail.drillStringsId);

          const originalDrillFluid = drillFluids.find(item => item._id === detail.drillFluidsId);
          const drillFluid = originalDrillFluid;
          const HYDRAULICS_MODEL_LABELS = Object.fromEntries(
            Object.entries(HYDRAULICS_MODEL_VALUES).map(([k, v]) => [v, k])
          );
          const displayRheoModel =
            detail?.rheo_model
              ? HYDRAULICS_MODEL_LABELS[detail.rheo_model] || detail.rheo_model
              : 'API-RP-YPL (2023)';
          const updatedDetail = {
            ...detail,
            drillStringsId: drillString
              ? `${drillString.name.trim()} @ ${drillString.MD.toFixed(hydraulics?.drillDetails?.units?.MD?.decimals)}${hydraulics?.drillDetails?.units?.MD?.label}`
              : '',
            drillFluidsId: drillFluid
              ? `${drillFluid.name.trim()} @ ${drillFluid.MD.toFixed(hydraulics?.drillDetails?.units?.MD?.decimals)}${hydraulics?.drillDetails?.units?.MD?.label}`
              : '',
            bit_depth: detail?.bit_depth ?? (detail?.hole_depth + detail?.bit_depth_offset),
            rpm: detail?.rpm ?? 0.0,
            correction_factor: detail?.correction_factor ?? 1.0,
            eq_losses: detail?.eq_losses ?? 0.0,
            target_data: detail?.target_data || 'None',
            well_init: detail?.well_init || {
              pipe: [],
              annular: []
            },
            rheo_model: displayRheoModel,
          };

          if (!originalDrillFluid || !drillString || !detail?.rheo_model) {
            updatedDetail.isDirty = true;
          }

          return updatedDetail;
        });
        setProperties(updatedRunDetails);
      } else {
        addHydraulicsDetails(unit);
      }
    }
  }, [hydraulics, observation.loading]);

  useEffect(() => {
    if (!rollover?.loading) {
      const pumps = rollover?.data?.[0]?.pumps_output;
      const spm = rollover?.data?.[0]?.pumps_spm;
      const multiplier = unit === 'SI' ? 1000 : 42;
      const unitLabel = unit === 'SI' ? ' lpm' : ' gpm';

      if (typeof pumps === 'number' && typeof spm === 'number') {
        const result = pumps * spm * multiplier;
        setCalculatedFlowRate(`${result.toFixed(1)}${unitLabel}`);
      } else {
        setCalculatedFlowRate('');
      }
    }
  }, [rollover, unit]);

  useEffect(() => {
    if (properties[0]?.isNewRow === true) {
      const id = properties[0]._id;
      setTimeout(() => {
        apiRef.current.scrollToIndexes({
          rowIndex: 0
        });
        apiRef.current.setCellMode(id, 'hole_depth', 'edit');
        setTimeout(() => {
          apiRef.current.setCellFocus(id, 'hole_depth');
        }, 50);
      }, 50);
      apiRef.current.setPage(0);
    }
  }, [properties?.length]);

  const addHydraulicsDetails = (unit) => {
    dispatch(addNewHydraulicsDetailsRow(unit));
  };

  const showError = (message, rowId) => {
    dispatch(enqueueSnackbar(message, 'error'));
    setInvalidRows(prev => ({ ...prev, [rowId]: true }));
    return false;
  };

  const showCuttingError = (message, rowId) => {
    dispatch(enqueueSnackbar(message, 'error'));
    setInvalidCuttinRows(prev => ({ ...prev, [rowId]: true }));
    return false;
  };

  const validateRunDetails = (runDetails) => {
    const { bit_depth, flow_in, hole_depth, sbp, rop, _id, rpm, correction_factor, eq_losses } = runDetails;
    const { thickness, porosity, diameter, density, _id: cuttingId } = updateCuttingData;
    const cuttingData = hydraulics?.units?.inputs?.cuttings_data;
    const minDiameter = cuttingData?.diameter?.min;
    const maxDiameter = cuttingData?.diameter?.max;
    const minThickness = cuttingData?.thickness?.min;
    const maxThickness = cuttingData?.thickness?.max;
    const minDensity = cuttingData?.density?.min;
    const maxDensity = cuttingData?.density?.max;
    const minPorosity = cuttingData?.porosity?.min;
    const maxPorosity = cuttingData?.porosity?.max;
    const min_hole_depth = hydraulics?.details?.units.inputs.hole_depth.min;
    const min_rop = hydraulics?.details?.units.inputs.rop.min;
    const max_rop = hydraulics?.details?.units.inputs.rop.max;
    const min_sbp = hydraulics?.details?.units.inputs.sbp.min;
    const min_flow_in = hydraulics?.details?.units.inputs.flow_in.min;
    const min_rpm = hydraulics?.details?.units.inputs.rpm.min;
    const max_rpm = hydraulics?.details?.units.inputs.rpm.max;
    const min_correction_factor = 0.25;
    const max_correction_factor = 3;
    const min_eqLosses = hydraulics.details.units.inputs.eq_losses.min;
    const max_eqLosses = hydraulics.details.units.inputs.eq_losses.max;

    if (Number(hole_depth) < min_hole_depth) return showError(HYDRAULICS_RUN_DETAILS.HOLE_DEPTH, _id);
    if (Number(bit_depth) < 0 || Number(bit_depth) > Number(hole_depth)) return showError(`Bit Depth should be in range 0 to Hole Depth (${hole_depth})`, _id);
    if (Number(rop) < min_rop || Number(rop) > max_rop) return showError(`ROP should be between ${min_rop} and ${max_rop}`, _id);
    if (Number(sbp) < min_sbp) return showError(HYDRAULICS_RUN_DETAILS.SBP, _id);
    if (Number(correction_factor) < min_correction_factor || Number(correction_factor) > max_correction_factor) return showError(`Correction Factor should be between ${min_correction_factor} and ${max_correction_factor}`, _id);
    if (Number(flow_in) < min_flow_in) return showError(HYDRAULICS_RUN_DETAILS.FLOW_IN, _id);
    if (Number(rpm) < min_rpm || Number(rpm) > max_rpm) return showError(`RPM should be between ${min_rpm} and ${max_rpm}`, _id);
    if (Number(flow_in) > 0) {
      if (Number(eq_losses) < min_eqLosses || Number(eq_losses) > max_eqLosses) return showError(`Equipment Losses should be between ${min_eqLosses} and ${max_eqLosses}`, _id);
    }
    if (Number(rop) > 0) {
      if (Number(diameter) < minDiameter || Number(diameter) > maxDiameter) return showCuttingError(`Diameter should be between ${minDiameter} and ${maxDiameter} ${cuttingData.diameter.label}`, cuttingId);
      if (Number(thickness) < minThickness || Number(thickness) > maxThickness) return showCuttingError(`Thickness should be between ${minThickness} and ${maxThickness} ${cuttingData.thickness.label}`, cuttingId);
      if (Number(density) < minDensity || Number(density) > maxDensity) return showCuttingError(`Density should be between ${minDensity} and ${maxDensity} ${cuttingData.density.label}`, cuttingId);
      if (Number(porosity) < minPorosity || Number(porosity) > maxPorosity) return showCuttingError(`Porosity should be between ${minPorosity} and ${maxPorosity} ${cuttingData.porosity.label}`, cuttingId);
    }
    return true;
  };

  const checkHydraulicsValues = (row) => {
    const invalidFields = [];
    const cuttingInvalidFields = [];
    const wellboreInvalidFields = [];
    const isInvalidNumber = (val) => isNaN(val) || val === '' || (typeof val === 'string' && val.trim() === '');

    if (row?.hole_depth === undefined || row?.hole_depth === null || isInvalidNumber(row.hole_depth)) {
      invalidFields.push('HOLE_DEPTH');
    }
    if (row?.bit_depth === undefined || row?.bit_depth === null || isInvalidNumber(row.bit_depth)) {
      invalidFields.push('BIT_DEPTH');
    }
    if (row?.rop === undefined || row?.rop === null || isInvalidNumber(row.rop)) {
      invalidFields.push('ROP');
    }
    if (Number(row?.flow_in) > 0 && (row?.eq_losses === undefined || row?.eq_losses === null || isInvalidNumber(row.eq_losses))) {
      invalidFields.push('Equipment Losses');
    }
    if (row?.flow_in === undefined || row?.flow_in === null || isInvalidNumber(row.flow_in)) {
      invalidFields.push('FLOW_RATE');
    }
    if (row?.sbp === undefined || row?.sbp === null || isInvalidNumber(row.sbp)) {
      invalidFields.push('SBP');
    }
    if (row?.rpm === undefined || row?.rpm === null || isInvalidNumber(row.rpm)) {
      invalidFields.push('RPM');
    }
    if (row?.correction_factor === undefined || row?.correction_factor === null || isInvalidNumber(row.correction_factor)) {
      invalidFields.push('Correction Factor');
    }

    // Mark invalid hydraulics row if any field is invalid
    if (invalidFields.length > 0) {
      setInvalidRows((prev) => ({ ...prev, [row._id]: true }));
    } else {
      setInvalidRows((prev) => ({ ...prev, [row._id]: false }));
    }

    if (row?.drillFluidsId === undefined || row?.drillFluidsId === null || row?.drillFluidsId === '') {
      wellboreInvalidFields.push('Drilling Fluid');
    }
    if (row?.drillStringsId === undefined || row?.drillStringsId === null || row?.drillStringsId === '') {
      wellboreInvalidFields.push('Drillstring');
    }
    if (wellbore?.pipe?.length || wellbore?.annular?.length) {
      const wellboreInitHasEmptyValue = Object.values(wellbore).some(section =>
        section.some(obj =>
          Object.values(obj).some(
            value => value === '' || value === null || value === undefined
          )
        )
      );
      if (wellboreInitHasEmptyValue) {
        wellboreInvalidFields.push('Wellbore Initialization');
      }
    }

    if (wellboreInvalidFields.length > 0) {
      setInvalidWellInitRows((prev) => ({ ...prev, [row._id]: true }));
      dispatch(
        enqueueSnackbar(
            `Please enter valid values for: ${wellboreInvalidFields.join(', ')}`,
            'error',
            new Date().getTime() + Math.random()
        )
      );
      return false;
    } else {
      setInvalidWellInitRows({});
    }

    // Check cutting data only if ROP > 0
    if (row.rop > 0) {
      if (updateCuttingData?.diameter === undefined || updateCuttingData?.diameter === null || isInvalidNumber(updateCuttingData.diameter)) {
        cuttingInvalidFields.push('Diameter');
      }
      if (updateCuttingData?.thickness === undefined || updateCuttingData?.thickness === null || isInvalidNumber(updateCuttingData.thickness)) {
        cuttingInvalidFields.push('Thickness');
      }
      if (updateCuttingData?.density === undefined || updateCuttingData?.density === null || isInvalidNumber(updateCuttingData.density)) {
        cuttingInvalidFields.push('Density');
      }
      if (updateCuttingData?.porosity === undefined || updateCuttingData?.porosity === null || isInvalidNumber(updateCuttingData.porosity)) {
        cuttingInvalidFields.push('Porosity');
      }

      if (cuttingInvalidFields.length > 0) {
        setInvalidCuttinRows((prev) => ({ ...prev, [updateCuttingData._id]: true }));
        dispatch(
          enqueueSnackbar(
            `Please enter valid values for: ${cuttingInvalidFields.join(', ')}`,
            'error',
            new Date().getTime() + Math.random()
          )
        );
        return false;
      } else {
        setInvalidCuttinRows((prev) => ({ ...prev, [updateCuttingData._id]: false }));
      }
    }

    // Final decision based on hydraulics validation
    if (invalidFields.length === 0 && cuttingInvalidFields.length === 0) {
      return validateRunDetails(row);
    } else {
      dispatch(
        enqueueSnackbar(
          `Please enter valid values for: ${invalidFields.join(', ')}`,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      return false;
    }
  };

  const transformWellbore = (wellbore, hydraulics) => {
    if (!hydraulics?.drillDetails?.hydraulicsDrillDetails?.drillFluids) return wellbore;

    const { drillFluids: originalDrillFLuids = [] } = hydraulics?.drillDetails?.hydraulicsDrillDetails || {};
    const units = hydraulics?.drillDetails?.units?.MD || { decimals: 2, label: 'm' };
    const drillFluids = [...originalDrillFLuids, WELLBORE_DRILL_FLUID];

    const fluidMap = drillFluids.reduce((map, item) => {
      const key = `${item?.name?.trim()} @ ${item?.MD.toFixed(units.decimals)}${units.label}`;
      map[key] = item?._id;
      return map;
    }, {});

    const mapWellInitData = (data) =>
      data.map((row) => ({
        from: unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.from, hydraulics.units.inputs?.well_init?.from?.conversionFactor) : Number(row.from),
        to: unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.to, hydraulics.units.inputs?.well_init?.to?.conversionFactor) : Number(row.to),
        fluid_id: fluidMap[row.fluid_id] || null,
      }));

    return {
      pipe: wellbore?.pipe.length ? mapWellInitData(wellbore.pipe) : [],
      annular: wellbore?.annular?.length ? mapWellInitData(wellbore.annular) : [],
    };
  };

  const transformRunsECDSpan = (targetData, hydraulics) => {
    if (!targetData.ecd_span) return [];
    return targetData?.ecd_span?.map((row) => ({
      name: row?.name,
      low_emw: unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.low_emw, hydraulics.units.inputs?.ecd_span?.low_emw?.conversionFactor) : Number(row.low_emw),
      high_emw: unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.high_emw, hydraulics.units.inputs?.ecd_span?.high_emw?.conversionFactor) : Number(row.high_emw),
    }));
  };

  const transformControlsTable = (targetData, hydraulics) => {
    if (!targetData.controls_table) return [];
    return targetData?.controls_table?.map((row) => {
      const parameter = CONTROL_TABLE_PARAMETER_MAP[row?.parameter] || row?.parameter;
      return ({
        maintain: row?.parameter === 'SBP' ? '-' : row?.maintain?.toLowerCase(),
        parameter: CONTROL_TABLE_PARAMETER_MAP[row?.parameter] || row?.parameter,
        from: unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.from, hydraulics.units.inputs?.target_data?.controls_table?.[parameter]?.conversionFactor) : Number(row.from),
        to: unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.to, hydraulics.units.inputs?.target_data?.controls_table?.[parameter]?.conversionFactor) : Number(row.to),
        step_size: row?.parameter === 'SBP' ? '-' : (unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.step_size, hydraulics.units.inputs?.target_data?.controls_table?.[parameter]?.conversionFactor) : Number(row.step_size)),
      });
    });
  };

  const getIsHydraulicsResults = (data) => {
    if (!data?.type) return false;

    const { type } = data;
    const conditions = {
      hydraulicsRun: !!data?.results?.summary,
      stripping: !!data?.isStrippingResults,
      parametricAnalysis: !!data?.isParametricResults,
      rollover: !!data?.isRolloverResults,
      displacement: !!data?.isDisplacementResults,
    };

    return conditions[type] || false;
  };

  const saveProperty = async (row) => {
    if (checkHydraulicsValues(row)) {
      const validationError = '';
      if (validationError === '') {
        const hydraulicsConversion = hydraulics.units.inputs;

        const converted_hole_depth = unit !== UNIT_SYSTEM.US
          ? convertUnitSystem(row.hole_depth, hydraulicsConversion?.hole_depth?.conversionFactor)
          : Number(row.hole_depth);

        const converted_bit_depth = unit !== UNIT_SYSTEM.US
          ? convertUnitSystem(row.bit_depth, hydraulicsConversion?.bit_depth?.conversionFactor)
          : Number(row.bit_depth);

        let converted_bit_depth_offset = converted_bit_depth - converted_hole_depth;
        if (unit !== UNIT_SYSTEM.US) {
          converted_bit_depth_offset = Number(converted_bit_depth_offset.toFixed(6));
        }

        const converted_rop = unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.rop, hydraulicsConversion?.rop?.conversionFactor) : Number(row.rop);
        const converted_eq_losses = unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.eq_losses, hydraulicsConversion?.eq_losses?.conversionFactor) : Number(row.eq_losses);
        const converted_flow_in = unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.flow_in, hydraulicsConversion?.flow_in?.conversionFactor) : Number(row.flow_in);
        const converted_spb = unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.sbp, hydraulicsConversion?.sbp?.conversionFactor) : Number(row.sbp);
        const cuttingsData = hydraulics?.units?.inputs?.cuttings_data;
        const cuttingsBody = {
          diameter: unit !== UNIT_SYSTEM.US ? convertUnitSystem(updateCuttingData.diameter, cuttingsData.diameter?.conversionFactor) : Number(updateCuttingData.diameter),
          thickness: unit !== UNIT_SYSTEM.US ? convertUnitSystem(updateCuttingData.thickness, cuttingsData.thickness?.conversionFactor) : Number(updateCuttingData.thickness),
          density: unit !== UNIT_SYSTEM.US ? convertUnitSystem(updateCuttingData.density, cuttingsData.density?.conversionFactor) : Number(updateCuttingData.density),
          porosity: unit !== UNIT_SYSTEM.US ? convertUnitSystem(updateCuttingData.porosity, cuttingsData.porosity?.conversionFactor) : Number(updateCuttingData.porosity),
        };
        const updatedWellbore = transformWellbore(wellbore, hydraulics);
        const updatedRunsECDSpan = transformRunsECDSpan(targetData, hydraulics);
        const updatedControlsTable = transformControlsTable(targetData, hydraulics);
        const body = {
          hole_depth: converted_hole_depth,
          bit_depth: converted_bit_depth,
          bit_depth_offset: converted_bit_depth_offset,
          rop: converted_rop,
          eq_losses: converted_flow_in > 0 ? converted_eq_losses : 0,
          flow_in: converted_flow_in,
          sbp: converted_spb > 0 ? converted_spb : 0.0,
          correction_factor: Number(row.correction_factor),
          rpm: unit !== UNIT_SYSTEM.US ? convertUnitSystem(row.rpm, hydraulicsConversion?.rpm?.conversionFactor) : Number(row.rpm),
          drillStringsId: hydraulics?.drillDetails?.hydraulicsDrillDetails?.drillStrings.filter((item) => `${item?.name?.trim()} @ ${item?.MD.toFixed(hydraulics?.drillDetails?.units?.MD?.decimals)}${hydraulics?.drillDetails?.units?.MD?.label}` === row?.drillStringsId)[0]._id,
          drillFluidsId: hydraulics?.drillDetails?.hydraulicsDrillDetails?.drillFluids.filter((item) => `${item?.name?.trim()} @ ${item?.MD.toFixed(hydraulics?.drillDetails?.units?.MD?.decimals)}${hydraulics?.drillDetails?.units?.MD?.label}` === row?.drillFluidsId)[0]._id,
          cuttings_data: cuttingsBody,
          rheo_model: HYDRAULICS_MODEL_VALUES[row?.rheo_model],
          target_data: (Object.keys(targetData).length === 0 || HIDE_TARGET_IN_RUN_TYPE.includes(dialogParameter))
            ? {}
            : {
                anchor_point: targetData?.anchor_point || 'None',
                target_ecd: targetData.target_ecd == null
                  ? null
                  : unit !== UNIT_SYSTEM.US
                    ? convertUnitSystem(
                      targetData.target_ecd,
                      hydraulics.units.inputs?.target_data?.target_ecd?.conversionFactor
                    )
                    : Number(targetData.target_ecd),
                ecd_span: updatedRunsECDSpan,
                controls_table: updatedControlsTable
              },
          well_init: updatedWellbore
        };
        if (!HIDE_TARGET_IN_RUN_TYPE.includes(dialogParameter)) {
          setTargetData({
            anchor_point: targetData?.anchor_point || 'None',
            target_ecd: targetData.target_ecd == null
              ? null
              : unit !== UNIT_SYSTEM.US
                ? convertUnitSystem(
                  targetData.target_ecd,
                  hydraulics.units.inputs?.target_data?.target_ecd?.conversionFactor
                )
                : Number(targetData.target_ecd),
            ecd_span: updatedRunsECDSpan,
            controls_table: updatedControlsTable
          });
        }
        if (row?.isNewRow) {
          const query = {
            runsId: data?._id ? data?._id : hydraulics.hydraulicsId,
            wellsInfoId: selectedJob?.wellsInfoId,
            type: data?.type
          };
          if (!checkPermissions(APP_ACTION_TYPES.CREATE, hydraulics?.details?.permissions)) {
            dispatch(
              enqueueSnackbar(
                'You do not have permission to create',
                'error',
                new Date().getTime() + Math.random()
              )
            );
            return;
          }
          await dispatch(createHydraulicsDetails(query, body));
        } else {
          if (!checkPermissions(APP_ACTION_TYPES.UPDATE, hydraulics?.details?.permissions)) {
            dispatch(
              enqueueSnackbar(
                'You do not have permission to update',
                'error',
                new Date().getTime() + Math.random()
              )
            );
            return;
          }
          const hydraulicsBody = {
            isHydraulicsResults: getIsHydraulicsResults(data),
            query: selectedJob?.fromWells
              ? {
                  wellsInfoId: selectedJob?.wellsInfoId,
                  type: data?.type
                }
              : {
                  jobId: selectedJob?._id,
                  type: data?.type,
                  wellsInfoId: selectedJob?.wellsInfoId,
                },
          };
          await dispatch(updateHydraulicsDetails(data?._id ? data?._id : hydraulics.hydraulicsId, body, hydraulicsBody));
        }
        setTimeout(() => {
          if (!apiRef?.current) return;
          Object.keys(row).forEach((field) => {
            apiRef.current.setCellMode(row._id, field, 'view');
          });
        }, 100);
      } else {
        if (validationError.length) {
          setInvalidRows(prev => ({ ...prev, [row._id]: true }));
        }
        dispatch(
          enqueueSnackbar(
            validationError,
            'error',
            new Date().getTime() + Math.random()
          )
        );
      }
    }
  };

  const analysisActionMap = {
    stripping: runStrippingAnalysis,
    parametricAnalysis: runParametricAnalysis,
    displacement: runDisplacement,
    rollover: runRolloverProxy,
    default: runHydraulics,
  };

  const runHydraulicsProxy = (selectedRunId) => {
    const requestBody = {
      query: selectedJob?.fromWells
        ? { wellsInfoId: selectedJob?.wellsInfoId }
        : { jobId: selectedJob?._id },
      runId: selectedRunId,
    };

    const analysisType = dialogParameter || 'default';
    const analysisAction = analysisActionMap[analysisType] || analysisActionMap.default;

    setLoader(true);
    dispatch(analysisAction(requestBody, () => {
      setLoader(false);
    }, () => {
      onCloseClick();
    }));
  };

  const closeHandler = () => {
    if (hydraulics?.loading || hydraulics.details.loading) return;
    if (unSavedExists) {
      handleClose(false);
      return;
    }
    onCloseClick();
  };

  const getModalTitle = () => {
    return (
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          {`${selectedJob?.Rig} | ${selectedJob?.Well} | ${data?.name}`} <CreatedByInfoDialog data={hydraulics?.details?.createdDetails} loading={hydraulics?.details?.loading || disableAction} />
        </Grid>
        <Grid item>
          {(!dialogParameter || dialogParameter === 'displacement') && hydraulics?.details?.data[0]?.hole_depth && hydraulics?.details?.data[0]?.bit_depth
            ? <Tooltip title={TOOLTIPS.volumeCalculator}>
              <span>
                <IconButton
                  disabled={hydraulics.details.loading || hydraulicsDisplacement?.loading || properties.some(item => item?.isDirty === true)}
                  onClick={() => {
                    setVolumeCalculatorModal(true);
                  }}
                >
                  <TableViewOutlined fontSize='large' />
                </IconButton>
              </span>
            </Tooltip>
            : null}
          <Tooltip title={TOOLTIPS.save}>
            <span>
              <IconButton
                disabled={hydraulics.details.loading || !(properties.some(item => item?.isDirty === true))}
                onClick={() => {
                  setTimeout(() => {
                    saveProperty(properties[0]);
                  }, 100);
                }}
              >
                <SaveRounded fontSize='large' />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={TOOLTIPS.submit}>
            <span>
              <IconButton
                onClick={() => {
                  runHydraulicsProxy(data?._id);
                }}
                disabled={hydraulics?.details?.data[0]?.isNewRow || hydraulicsExitRunIcon || hydraulics?.loading || hydraulics.details.loading || properties.some(item => item.isDirty === true) || rollover?.loading || stripping?.loading || hydraulicsParameter?.loading || hydraulicsDisplacement?.loading || properties.some(item => item.isDirtyAccordion === true) || accordionProperty.some(item => item.isDirty === true)}
              >
                <LogoutOutlined fontSize='large' />
              </IconButton>
            </span>
          </Tooltip>
          {isHydraulicsAdmin
            ? (
              <Tooltip title={TOOLTIPS.viewPermissions}>
                <span>
                  <IconButton
                    variant="solid"
                    key="permissions"
                    disabled={hydraulics.details.loading || hydraulics?.loading || properties.some(item => item.isDirtyAccordion === true) || accordionProperty.some(item => item.isDirty === true) || properties.some(item => item?.isDirty === true)}
                    sx={{ color: hydraulics?.details?.permissionId && 'green' }}
                    onClick={() => {
                      setPermissions({
                        open: true,
                        data: {
                          ...data,
                          permissionId: hydraulics?.details?.permissionId ?? null
                        }
                      });
                    }}
                  >
                    <PersonAddAlt fontSize='large' />
                  </IconButton>
                </span>
              </Tooltip>
              )
            : null}
          <IconButton
            onClick={closeHandler}
            disabled={hydraulics?.loading || hydraulics.details.loading}
          >
            <CancelPresentationRounded fontSize='large' />
          </IconButton>
        </Grid>
      </Grid>
    );
  };

  const updateData = (id, field, value) => {
    setProperties(prevProperties => {
      const updatedProperties = prevProperties.map(item => {
        if (item._id === id) {
          const updatedItem = {
            ...item,
            [field]: value,
            isDirty: value !== item[field],
          };

          if (
            field === 'hole_depth' &&
            (item.bit_depth === '' || item.bit_depth === null || item.bit_depth === undefined || item.bit_depth === item.hole_depth)
          ) {
            updatedItem.bit_depth = value;
          }

          return updatedItem;
        }
        return item;
      });

      return updatedProperties;
    });
  };

  const renderValueCell = (params) => {
    return <SelectEditInputTextField numberFormatOnly {...params} updateData={updateData} />;
  };

  const renderModelCell = (params) => {
    return (
      <SelectEditValueTypes
        {...params}
        closeCellAfterSelect={true}
        updateData={updateData}
        data={HYDRAULICS_MODEL}
      />
    );
  };

  const isLoading =
    hydraulics?.details?.loading ||
    hydraulics?.drillDetails?.loading ||
    rollover?.loading ||
    stripping?.loading ||
    hydraulicsParameter?.loading ||
    hydraulicsDisplacement?.loading;

  return (
    <React.Fragment>
      <ModalDialog
        title={getModalTitle()}
        isOpen={isOpen}
        onClose={closeHandler}
        dialogClass={classes.dialogModal}
      >

        {/* Run Parameter Accordian */}

        <Accordion defaultExpanded style={{
          marginTop: '1%'
        }} className={classes.accordianBorderDisplay}>
          <AccordionSummary className={classes.accordianSummary} expandIcon={<GridExpandMoreIcon />}>
            <Typography variant="h6" color={COLORS.BLACK} fontWeight="500">
              Run Parameters
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{
            padding: '0px 0px 0px 5px',
          }}>
            <Grid container>
              <Grid item xs={12}>
                <Datagrid
                  apiRef={apiRef}
                  data={properties}
                  sx={{
                    marginLeft: '-6px',
                    '.MuiDataGrid-cell': {
                      fontSize: '1rem',
                      fontWeight: 900,
                      pointerEvents: loader ? 'none' : 'auto',
                      backgroundColor: loader ? '#f5f5f5' : 'inherit'
                    },
                    '.MuiDataGrid-columnHeader': {
                      fontSize: '1.2rem',
                      fontWeight: '900 !important'
                    },
                    '& .MuiDataGrid-footerContainer': {
                      display: 'none',
                    },
                  }}
                  loading={hydraulics.details.loading || hydraulics?.drillDetails?.loading || rollover?.loading || stripping?.loading || hydraulicsParameter?.loading || hydraulicsDisplacement?.loading}
                  columns={columns(renderValueCell, renderModelCell, hydraulics?.details?.units.inputs, unit, properties, dialogParameter, hydraulicParameterData, anchorPoint)}
                  onRowClick={(params, evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                  }}
                  disableStickyHeader={false}
                  autoHeight={false}
                  autoheight
                  height={'150px'}
                  isRowSelectable={() => !loader}
                  getRowClassName={(params) =>
                    loader ? 'Mui-disabled' : (invalidRows[params.id] ? classes.invalidRow : '')}
                  pageSize={100}
                  editMode="cell"
                  toolbar={{
                    options: {
                      columns: false,
                      filters: false,
                      density: false,
                      export: false
                    },
                  }}
                  permissions={!properties[0]?.isNewRow && hydraulics?.details?.permissions}
                />
              </Grid>
            </Grid>
          </AccordionDetails>

          {/* Wellbore Accordian */}

        </Accordion>
        <Accordion className={classes.accordianBorderDisplay} defaultExpanded>
          <AccordionSummary className={classes.accordianSummary} expandIcon={<GridExpandMoreIcon />}>
            <Typography variant="h6" color={COLORS.BLACK} fontWeight="500">
              Wellbore
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{
            padding: '0px 0px 0px 5px',
          }}>
            <Grid container>
              <Grid item xs={12}>
                <Wellbore
                  checkWellbore={checkWellbore}
                  properties={properties}
                  setProperties={setProperties}
                  anchorPoint={anchorPoint}
                  targetECD={targetECD}
                  setAnchorPoint={setAnchorPoint}
                  setTargetECD={setTargetECD}
                  setTargetData={setTargetData}
                  targetData={targetData}
                  data={data}
                  selectedJob={selectedJob}
                  setWellbore={setWellbore}
                  wellbore={wellbore}
                  setParameterDirty={setProperties}
                  proxyLoader={loader}
                  hydraulicParameterData={hydraulicParameterData}
                  setCheckWellbore={setCheckWellbore}
                  dialogParameter={dialogParameter}
                  initialTargetData={initialTargetData}
                  invalidWellInitRows={invalidWellInitRows}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        {Number(properties?.[0]?.rop) > 0 && (
          <Accordion className={classes.accordianBorderDisplay} defaultExpanded>
            <AccordionSummary className={classes.accordianSummary}
              expandIcon={<GridExpandMoreIcon />}>
              <Typography variant="h6" color={COLORS.BLACK} fontWeight="500">
                Cuttings
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0px 0px 5px 5px' }}>
              <Grid container>
                <Grid item xs={12}>
                  <CuttingPropertyModal
                    data={cuttingData}
                    setCuttingData={setCuttingData}
                    setUpdateCuttingData={setUpdateCuttingData}
                    invalidCuttingRows={invalidCuttingRows}
                    setParameterDirty={setProperties}
                    proxyLoader={loader}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

        {dialogParameter === 'rollover' && (
  <Accordion className={classes.accordianBorderDisplay} defaultExpanded>
    <AccordionSummary
      className={classes.accordianSummary}
      expandIcon={<GridExpandMoreIcon />}
      sx={{ width: '100%' }}
    >
      <Grid container width={'990px'} alignItems="center" justifyContent="space-between">
        <Typography variant="h6" fontWeight="500">
          Rollover
          {calculatedFlowRate && (
            <span style={{ color: COLORS.LIGHT_GREY }}>
              {` (Calculated Flow Rate: ${calculatedFlowRate})`}
            </span>
          )}
          <CreatedByInfoDialog data={rollover?.createdDetails} loading={rollover?.loading || disableAction} />
        </Typography>

        {/* <IconButton
          variant="solid"
          sx={{ color: hydraulics?.mudPumps?.data?.length ? 'green' : 'default' }}
          onClick={(e) => {
            e.stopPropagation();
            setShowMudPumps(true);
          }}
          onFocus={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <HeatPump />
        </IconButton> */}
      </Grid>
    </AccordionSummary>

    <AccordionDetails sx={{ padding: '0px 0px 5px 5px' }}>
      <Grid container>
        <Grid item xs={12}>
          <RolloverModal
            selectedJob={selectedJob}
            rowData={data}
            proxyLoader={loader}
            setAccordionProperty={setAccordionProperty}
          />
        </Grid>
      </Grid>
    </AccordionDetails>
  </Accordion>
        )}

        {dialogParameter === 'stripping' && (
          <Accordion className={classes.accordianBorderDisplay} defaultExpanded>
            <AccordionSummary className={classes.accordianSummary} expandIcon={<GridExpandMoreIcon />}>
              <Typography variant="h6" color={COLORS.BLACK} fontWeight="500">
                Stripping <CreatedByInfoDialog data={stripping?.createdDetails} loading={stripping?.loading || disableAction} />
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0px 0px 5px 5px' }}>
              <Grid container>
                <Grid item xs={12}>
                  <StrippingModal
                    setAccordionProperty={setAccordionProperty}
                    selectedJob={selectedJob}
                    rowData={{
                      ...data,
                      run_details: properties[0]
                    }}
                    proxyLoader={loader}
                    data={data}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

        {dialogParameter === 'parametricAnalysis' && (
          <Accordion className={classes.accordianBorderDisplay} defaultExpanded>
            <AccordionSummary className={classes.accordianSummary} expandIcon={<GridExpandMoreIcon />}>
              <Typography variant="h6" color={COLORS.BLACK} fontWeight="500">
                Parametric Analysis <CreatedByInfoDialog data={hydraulicsParameter?.createdDetails} loading={hydraulicsParameter?.loading || disableAction} />
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0px 0px 5px 5px' }}>
              <Grid container>
                <Grid item xs={12}>
                  <ParametricAnalysisModal
                    selectedJob={selectedJob}
                    rowData={data}
                    setHydraulicsParameterData={setHydraulicsParameterData}
                    setHydraulicsProperties={setProperties}
                    proxyLoader={loader}
                    setAccordionProperty={setAccordionProperty}
                    saveHydraulicDetails={() => {
                      const wellBoreData = hydraulics?.details?.data?.[0];
                      if (wellBoreData?.well_init?.pipe.length > 0 || wellBoreData?.well_init?.annular.length) {
                        const updatedData = (hydraulics?.details?.data || []).map(item => ({
                          ...item,
                          isDirty: true,
                          well_init: {
                            pipe: [],
                            annular: []
                          },
                        }));

                        dispatch({
                          type: REDUX_ACTIONS.HYDRAULICS_DETAILS_LIST_SUCCESS,
                          payload: {
                            unModifiedData: hydraulics?.details?.unModifiedData,
                            data: updatedData,
                            paginatedElements: updatedData.length,
                            units: hydraulics?.details?.units
                          },
                        });
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

        {dialogParameter === 'displacement' && (
          <Accordion className={classes.accordianBorderDisplay} defaultExpanded>
            <AccordionSummary className={classes.accordianSummary} expandIcon={<GridExpandMoreIcon />}>
              <Typography variant="h6" color={COLORS.BLACK} fontWeight="500">
                Displacement <CreatedByInfoDialog data={hydraulicsDisplacement?.createdDetails} loading={hydraulicsDisplacement?.loading || disableAction} />
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0px 0px 5px 5px' }}>
              <Grid container>
                <Grid item xs={12}>
                  <DisplacementModal
                    selectedJob={selectedJob}
                    rowData={data}
                    setAccordionProperty={setAccordionProperty}
                    proxyLoader={loader}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}
        <Divider />
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{
            marginTop: '15px',
            marginBottom: '15px'
          }}
        >
          {SHORTCUT_LISTS_HYDRAULICS.map((item) => (
            <Grid item key={item.key}>
              <Button
                disabled={isLoading}
                variant="contained"
                startIcon={<ShortcutOutlined sx={{ fontSize: 16 }} />}
                onClick={() => handleOpen(item.key)}
                sx={{
                  backgroundColor: isLoading ? '#555' : '#111',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 500,
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#222',
                  },
                  minWidth: 'auto',
                  px: 2,
                  py: 0.5,
                  fontSize: '1rem',
                }}
              >
                {item.label}
              </Button>
            </Grid>
          ))}
        </Grid>

        {
          showMudPumps
            ? <MudPumpModel
              selectedJob={selectedJob}
              isOpen={showMudPumps}
              onCloseClick={() => {
                setShowMudPumps(false);
              }}
            />
            : null
        }

        {
          volumeCalculatorModal && <WellboreVolumeModal
            isOpen={volumeCalculatorModal}
            data={data}
            onCloseClick={() => {
              setVolumeCalculatorModal(false);
            }}
          />
        }

        {openModal === 'survey' && (
          <SurveyModal
            isOpen
            onCloseClick={handleCloseDialog}
            surveyData={wellDetails}
          />
        )}

        {openModal === 'geometry' && (
          <GeometryModal
            isOpen
            onCloseClick={handleCloseDialog}
            geometryData={wellDetails}
          />
        )}

        {openModal === 'drillString' && (
          <DrillStringModal
            isOpen
            onCloseClick={handleCloseDialog}
            drillStringData={wellDetails}
          />
        )}

        {openModal === 'drillFluid' && (
          <DrillFluidModal
            isOpen
            onCloseClick={handleCloseDialog}
            drillFluidData={wellDetails}
          />
        )}

        {openModal === 'window' && (
          <WindowModal
            isOpen
            onCloseClick={handleCloseDialog}
            windowData={wellDetails}
          />
        )}

        {permissions?.open
          ? (
            <PermissionsModal
              isOpen={permissions?.open}
              data={
                {
                  ...permissions?.data,
                  collection: {
                    collectionName: PERMISSION_DIALOG_SOURCES?.wellsHydraulics?.collectionName,
                    label: _.startCase(data?.type)
                  },
                }
              }
              onCloseClick={() => {
                setPermissions({
                  open: false,
                  data: {}
                });
              }}
              refreshParentDialog={() => {
                dispatch(listHydraulicsDetails(data));
              }}
            />
            )
          : null}

        <UnsavedChangesModal />
      </ModalDialog>
    </React.Fragment>
  );
};
HydraulicsDetailsModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  selectedJob: PropTypes.object,
  data: PropTypes.any,
  isOpen: PropTypes.bool.isRequired,
  dialogParameter: PropTypes.string,
  wellDetails: PropTypes.any,
};
HydraulicsDetailsModal.defaultProps = {
  selectedJob: {}
};

export default HydraulicsDetailsModal;
